import { analyticsUrl } from "@/content/company";

export type NavLink = { label: string; href: string; highlight?: boolean; external?: boolean };

// Âncoras da própria landing page — a home é a única página com conteúdo
// seccionado; as demais rotas (SAT Labs Cast, Privacidade) são páginas à parte.
// SAT Labs Analytics é um produto à parte, hospedado fora do site (subdomínio
// próprio) — por isso "external", abre em nova aba em vez de navegação interna.
export const primaryNav: NavLink[] = [
  { label: "Clientes", href: "/#clientes" },
  { label: "Soluções", href: "/#solucoes" },
  { label: "Processo", href: "/#como-funciona" },
  { label: "Integrações", href: "/#integracoes" },
  { label: "FAQ", href: "/#faq" },
  // pré-venda em destaque — recebe tratamento visual diferenciado no menu.
  { label: "SAT Labs Cast", href: "/sat-labs-cast", highlight: true },
  {
    label: "Analytics",
    href: analyticsUrl,
    external: true,
  },
];

export const footerColumns = [
  {
    title: "Site",
    links: [
      { label: "Clientes", href: "/#clientes" },
      { label: "Soluções", href: "/#solucoes" },
      { label: "Processo", href: "/#como-funciona" },
      { label: "Integrações", href: "/#integracoes" },
      { label: "FAQ", href: "/#faq" },
    ],
  },
  {
    title: "SAT Labs",
    links: [
      { label: "SAT Labs Cast", href: "/sat-labs-cast" },
      {
        label: "Analytics",
        href: analyticsUrl,
        external: true,
      },
      { label: "Política de privacidade", href: "/privacidade" },
    ],
  },
];
